import { Box, Flex, FormButton, PaperSection } from '@shared/components';
import { WithPermission } from '@shared/permissions';
import {
  AppPermissionButtonGroup,
  AppPermissionTitle,
  FormPermissionList,
  PermissionListFormProvider,
  type AppOptions,
} from '@user-management/permission-list';
import { APP_PERMISSIONS } from '@user-management/permissions';
import { useParams } from '@user-management/router';

export default function PermissionDetailsByAppPage() {
  const { app } = useParams('/roles-and-permissions/:appRoleId/permissions/:app');

  return (
    <PermissionListFormProvider>
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(6),
          flexDirection: 'column',
        })}
      >
        <PaperSection title='Permissions'>
          <Flex
            sx={{
              flexDirection: 'column',
              gap: (theme) => theme.spacing(6),
              p: (theme) => theme.spacing(6),
            }}
          >
            <AppPermissionButtonGroup />
            <AppPermissionTitle variant={app as AppOptions} />
            <FormPermissionList />
          </Flex>
        </PaperSection>
        <WithPermission requiredPermission={APP_PERMISSIONS.SETTING.ROLE.UPDATE}>
          <Box>
            <FormButton label='Save Changes' />
          </Box>
        </WithPermission>
      </Flex>
    </PermissionListFormProvider>
  );
}
